import React from "react";
import './Cards.scss'
import { useDispatch, useSelector } from 'react-redux';
import { FetchIsFavoriteL1Action, FetchIsFavoriteL1L2Action, FetchMIL1Action, FetchMIL2Action } from '../../redux/action/CommodityPackagingAction';
import { Card, Slot, Button, Tooltip, ButtonGroup, Icon, CardV2 } from "pepsico-ds";
import { useNavigate, useParams } from "react-router-dom";
import './Cards.scss'
import unpinnedImage from '../../assets/Unpinned_Img.svg';
import pinnedImage from '../../assets/Pinned_img.svg';

function CommodityCard({ card, color=null, subCategories=null, sources=null, capabilities=null, isL1Page=false, isL2Page=false, userEmailId="", isShowPin=false }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

	const { category } = useParams();

	const userData = useSelector((state) => state.getLandingPageReducer);
	const miL2Data = useSelector((state) => state.getMIL2Reducer);

	const isFavoriteFunctionality = (card) => {

		if(isL1Page){
			let l1req = {
			"email": userData?.emailId,
			"l1Category": card?.name,
			"isFavorite": card.isFavorite ? "false" : "true"
			};

			// dispatch(FetchIsFavoriteL1Action(l1req)).then(() => {
			dispatch(FetchIsFavoriteL1L2Action(l1req)).then(() => {
				dispatch(FetchMIL1Action(userData?.emailId));
			});
		}
		

		if(isL2Page){
			let l1l2req = {
				"email": userData?.emailId,
				"l1Category": miL2Data?.l1Category,
				"l2Category": card?.name,
				"isFavorite": card.isFavorite ? "false" : "true"
			}
			dispatch(FetchIsFavoriteL1L2Action(l1l2req)).then(() => {
				dispatch(FetchMIL2Action(category, userData?.emailId));
			});
		}
		
	};
	

	/* istanbul ignore next */
	return (
		<>
			<CardV2
				cardBody={{
					isDark: false,
					slot: <div
									style={{
										minHeight: isShowPin ? "310px" : "150px",
										width: "100%",
										height: "100%",
										display: "flex",
										flexDirection: "column",
										justifyContent: "space-between",
										fontFamily: 'Inter'
									}}
								>
									<div className="card-title-container">
										<div className="card-title" style={{color: "#2d2d2d", lineHeight: "28px", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
											{card.name}
											{/* { isShowPin && ( */}
												<span
													onClick={()=> isFavoriteFunctionality(card)}
													onKeyDown={(e) => {
														if (e.key === 'Enter' || e.key === ' ') {
															e.preventDefault();
															isFavoriteFunctionality(card);
														}
													}}
													role="button"
													tabIndex={0}
													style={{cursor: "pointer"}}
												>
													<img src={card?.isFavorite ? pinnedImage : unpinnedImage} alt="card" style={{width: "20px", height: "20px"}} />
													{/* <Icon alt="" icon="keep" size="small" /> */}
												</span>
											{/* )
												
											} */}
										</div>
										<div className="card-description" style={{display: "flex", height: isShowPin ? "250px" : "135px" }}>
											{/* {
												card?.image &&
												<div style={{height: "58px", width: "20%", marginRight: "16px", display: "flex", justifyContent: "center"}}>
													<img 
														alt="img" 
														src ={card.image} 
														style={{
															width: '58px',
															height: '58px',
															objectFit: 'cover',
															display: 'block',
															borderRadius: '8px 8px 0 0'
													}} />
												</div>
											} */}
											<div style={{color: "#4B4B4B", fontSize: "14px", lineHeight: "20px", display: "flex", flexDirection: "column", height: "100%" }}>
												{/* <div dangerouslySetInnerHTML={{ __html: card.description }} /> */}
												{
													subCategories &&
													<div>
													 	<span style={{fontWeight: 700}}>SUB-CATEGORIES:</span> {subCategories}
													</div>
												}
												{
													sources &&
													<div style={{ marginTop:"8px" }}>
													 	<span style={{fontWeight: 700}}>SOURCES:</span> {sources}
													</div>
												}
												{
													capabilities &&
													<div style={{ marginTop:"8px" }}>
													 	<span style={{fontWeight: 700}}>CAPABILITIES:</span> {capabilities}
													</div>
												}
												{/* {
													isPackagingCard && card?.isDirects &&
													<div style={{ marginTop:"8px" }}>
													 	<span>Total number of Price Indices available:</span> <span style={{fontWeight: 700}}>{card?.count}</span>
													</div>
												}
												{
													isPackagingCard && !card?.isDirects &&
													<div style={{ marginTop:"8px" }}>
													 	<span>Total number of Indirect sub-categories:</span> <span style={{fontWeight: 700}}>{card?.count}</span>
													</div>
												} */}

												{
													card?.count &&
													<div style={{ marginTop:"auto"}}>
													 	<span>Total number of price indices / nodes available: </span> <span style={{fontWeight: 700}}>{card?.count}</span>
													</div>
												}
												
												
												{/* <div style={{ marginTop: card?.name == "Oils & Grains" || card?.name == "Ingredient & Sweeteners" ? '-5px' : "8px"}}>{card.description}
													 {card?.data && <span style={{fontWeight: 700}}>{card?.data?.productCount || card?.data?.reportCount}</span>}
												</div> */}
												{card?.dataAsOn && <div className="kpi-card-last-update" style={{ marginTop: '8px' }}>Data As On: {card?.dataAsOn} {card?.refreshFrequency ? ' | Refresh Frequency: ' + card?.refreshFrequency : ''}</div>}
												{card?.subDescription && <div className="powered-by-text" style={{ color: color || '#5C4EC9' }}>{card.subDescription}</div> }
											</div>
										</div>
									</div>
									<div
										style={{
											display: 'flex',
											alignItems: 'flex-end',
											justifyContent: 'flex-end'
										}}
										className="app-card-footer"
									>
										<Button
											className=""
											iconTrailing="arrow_forward"
											size="large"
											style={{}}
											text={card.buttonText}
											variant="secondary"
											disabled={card.buttonText==="View Sub-categories" ||card.buttonText==="View Details" || card.buttonText==="Launch" ? false : true}
											onClick={function clickButton() {
												if(card.url) {
													navigate(card.url);

												}
											}}
										/>
									</div>
								</div>,
					
					type: 'slot',
					
				}}
				className=''
				maxScrollHeight="90px"
				state="interactive"
				style={{}}
				type="basic"
				viewport="desktop"
			/>
			
		</>
	);
}

export default CommodityCard;
